import ResultContainer from './resultContainer';

export default ResultContainer;